// Types

// Services
import { gql } from 'graphql-request';
import { useQuery, UseQueryResult } from 'react-query';
import { graphqlConfig } from 'services/config/graphqlConfig';
import { UserNearestPracticeTest } from './types';

export const useUserNearestPracticeTest = (classId?: number) => {
  const { client } = graphqlConfig();

  const data: UseQueryResult<UserNearestPracticeTest, Error> = useQuery<UserNearestPracticeTest, Error>(['userNearerstPracticeTest'], async () => client.request(
    gql`
    query UserNearestTest($classId: Float!) {
      userNearestTest(classId: $classId) {
        id
        name
        classId
        details
        link
        status
        dueDate
        attachments {
          id
          attachment
          teacherAttachment
        }
        receivedMark {
          QuantitativeScore
          englishScore
          listening
          mathScore
          reading
          speaking
          totalScore
          verbalScore
          writing
        }
      }
    }
    `,
    {
      classId: classId || undefined
    }
  ).catch((error) => console.error(error)));
  return data;
};
